import { gql } from '@apollo/client';
export const REGISTER_CANDIDATE_TO_DRIVE = gql `
  mutation driveGuestRegistration($drive_schedule_id: Int) {
    sch_register_guest(drive_schedule_id: $drive_schedule_id) {
      data {
        drive_occurrence_guest {
          drive_schedule_id
          guest_id
          id
          pay_item {
            id
            order_items {
              order_id
            }
          }
        }
        guest {
          email
          external_id
          id
          name
          user_id
        }
      }
      success_count
      error_count
    }
  }
`;
